import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BlankLayout = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const checkUser = () => {
      const userStr = localStorage.getItem("user");
      const user = userStr ? JSON.parse(userStr) : null;
      const currentPath = window.location.pathname;
      
      // Allow access to business-details page even if logged in
      if (user && currentPath !== "/business-details" && currentPath !== "/login" && currentPath !== "/signup" && currentPath !== "/forget-password") {
        // If profile is incomplete, redirect to business-details
        if (!user.profile_completed) {
          navigate("/business-details");
        } else {
          navigate("/dashboard");
        }
      }
    };

    checkUser();
  }, [navigate]);
  return <main>{children}</main>;
};

export default BlankLayout;
